import { wccModules } from 'enums/wccModules';
import { inject, injectable } from 'inversify';
import { Subscribable } from 'knockout';
import './progress.html';
import './progress.scss';

export interface AttachmentProgressControlVMConfig {
    progress: Subscribable<number>
    icon: Subscribable<string>
    size: Subscribable<number>
}

@injectable()
export default class AttachmentProgressControlVM {
    strokeWidth = 2;
    color = '#5ca2dd';

    progress: Subscribable<number>
    icon: Subscribable<string>
    size: Subscribable<number>

    constructor(
        @inject(wccModules.componentConfig) config: AttachmentProgressControlVMConfig,
        @inject(wccModules.componentInfo) info: ko.components.ComponentInfo
    ) {
        this.progress = config.progress;
        this.icon = config.icon;
        this.size = config.size;

        const iconSize = ko.pureComputed(() => system.toEven(Math.floor(this.size() * 0.45)));

        ko.applyBindingsToNode(info.element, {
            'css': {
                'wcc-attachment-controls-progress': true
            },

            'style': {
                'font-size': iconSize.toPx().extend({ deferred: true })
            }
        }, this);
    }
}